// extracted by mini-css-extract-plugin
module.exports = {"Modal":"modal_Modal__3uRY6","CloseButton":"modal_CloseButton__zUyX5","OptionsButton":"modal_OptionsButton__3pk8E","Button":"modal_Button__RyeqP"};